/**
 * My API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CertificateDto } from './certificateDto';
import { PhotoCollectionDto } from './photoCollectionDto';
import { PhotoDto } from './photoDto';
import { PlantingSitePartnerDto } from './plantingSitePartnerDto';
import { PlantingSiteSpeciesDto } from './plantingSiteSpeciesDto';
import { PlantingSiteAreaDto } from "./plantingSiteAreaDto";

export enum PhotoPosition {
    top = 1,
    middle = 2,
    bottom = 3
}

export interface PlantingSiteDetailDto {
    id: string;
    title?: string;
    description?: string;
    country?: string;
    region?: string;
    landOwner?: string;
    landOwnerDescription?: string;
    landOwnerPhoto?: PhotoDto;
    plantingDate?: Date;
    singleDonorMessage?: string;
    lat?: number;
    lon?: number;
    headerPhoto?: PhotoDto;
    photoPosition?: PhotoPosition,
    certificates: Array<CertificateDto>;
    partners: Array<PlantingSitePartnerDto>;
    areas: Array<PlantingSiteAreaDto>
    species: Array<PlantingSiteSpeciesDto>;
    collections: Array<PhotoCollectionDto>;
    code?: string;
    totalTrees?: number;
    availableTrees?: number;
    newLandOwnerPhoto?: File;
    pdfUrl?: string;
    enabledBanner?: boolean; 
    bannerHeader?: string; 
    bannerDescription? :string; 
}
